module.exports = __webpack_public_path__ + "static/media/c-comparison.fb442211.png";